import React from 'react';

// import Body from './components/Body';
import UnderConstruction from './components/UnderConstruction';

const App: React.FC = () => {
    return (
        <UnderConstruction />
        // <div className="bg-background dark:bg-dark-background text-black dark:text-white min-h-screen">
        //     <Body />
        // </div>
    );
};

export default App;
